module.exports = __webpack_public_path__ + "media/parents.0823c039.mp3";